import { IValues } from './types'

export const defaultValues: IValues = {
  contribution: 5000,
  period: 5,
  rate: 'month',
}
